import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "95mm",
  height: "39mm",
  viewBox: "0 0 95 39",
  version: "1.1",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = {
  fill: "#ffffff",
  "font-family": "Open Sans, sans-serif",
  "font-size": "8px",
  "text-anchor": "middle",
  transform: "translate(47.5, 20.33) rotate(-15.3061) translate(-47.5, -20.33)",
  x: "47.5",
  y: "20.33",
  "alignment-baseline": "middle"
}

import labels from "../../shared/labels";

export default /*@__PURE__*/_defineComponent({
  __name: 'sold-overlay',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [
    _cache[0] || (_cache[0] = _createElementVNode("path", {
      fill: "#000000",
      style: {"image-rendering":"auto"},
      d: "M 0,26 95,0 V 13 L 0,39 Z"
    }, null, -1 /* HOISTED */)),
    _createElementVNode("text", _hoisted_2, _toDisplayString(_unref(labels).frontendProductpage.soldOverlayText), 1 /* TEXT */)
  ]))
}
}

})